import { connect } from 'react-redux'
import DriverViewSessionHistoryOld from '../../components/drivers/DriverViewSessionHistoryOld'
import { IStoreState } from '../../types/index'
import DriverViewSchedule, { IDriverViewScheduleProps } from 'src/components/drivers/DriverViewSchedule'
import DriverEditSchedule from 'src/components/drivers/DriverEditSchedule'
import { sendPushNotificationToDriver } from 'src/state/actions/drivers'

const mapStateToProps = (state: IStoreState, props: any) => {
  const operatorId = props.operatorId
  const currentOperator = state.drivers.items[operatorId]
  return {
    operatorId: props.operatorId,
    orgId: state.organizations.currentOrgId,
    currentOperator
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    sendPushNotificationToDriver: (operatorId: string, message: string) =>
      dispatch(sendPushNotificationToDriver(operatorId, message))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DriverEditSchedule)



// WEBPACK FOOTER //
// ./src/containers/drivers/DriverEditSchedule.ts